import './navbar.css';

import { IconBut } from '../ui/buttons.js';
// import { useState } from 'react';
// import { useRef } from 'react';
import { useContext, useState } from 'react';

import { StateContext, DispatchStateContext } from '../contexts.js';

import { changeTheme } from '../ui/theme.js';


function Navbar({ scroll }) {
    const [showMenu, setShow] = useState(false);

    return (
        <div className={"landing-nav" + (scroll ? " scroll" : '')}>
            <div className='fw pad'>
                <div className="lap-nav nav fw flex mid-align">
                    <div className="hero-title fh"> LearnXcess </div>
                    {/* <div className="menu flex mid-align">
                        <NavLink linkTo="Home" url="/home" />
                        <NavLink linkTo="About" url="/about" />
                        <NavLink linkTo="Projects" url="/projects" />
                        <NavLink linkTo="Contact Me" url="/contact" />
                    </div> */}
                    <div className="flex mid-align gap-2">
                        <IconBut className="fa-solid fa-sun sun" onClick={changeTheme} />
                        <IconBut className="fa-solid fa-moon moon" onClick={changeTheme} />
                        <IconBut className="fa-solid fa-magnifying-glass" />
                    </div>
                </div>

                <div className="mob-nav nav fw flex mid-align">
                    <div className="hero-title fh"> LearnXcess </div>
                    <div className="flex mid-align">
                        <IconBut className="fa-solid fa-sun sun" onClick={changeTheme} />
                        <IconBut className="fa-solid fa-moon moon" onClick={changeTheme} />
                        <IconBut className="fa-solid fa-magnifying-glass" />

                        {/* { showMenu ? 
                            <IconBut className="fa-solid fa-xmark" hover="Close" handleClick={ToggleMenu} sr="close menu"/>
                            :
                            <IconBut className="fa-solid fa-bars" hover="Menu" handleClick={ToggleMenu} sr="open menu"/>
                        } */}
                    </div>
                </div>
                {/* <div className={"menu abs" + (showMenu? "" : " hide")} onClick={ToggleMenu}>
                    <div className='wrapper max'>
                        <div className="content fw flex-col">
                            <NavLink linkTo="Home" url="/home" />
                            <NavLink linkTo="About" url="/about" />
                            <NavLink linkTo="Projects" url="/projects" />
                            <NavLink linkTo="Contact Me" url="/contact" />
                        </div>
                    </div>
                </div> */}

            </div>
        </div>
    )

    function toggleMenu(bool) {
        setShow(bool);
    }

}

function NavLink({ linkTo, url }) {
    const fullState = useContext(StateContext), view = fullState.view;
    const dispatch = useContext(DispatchStateContext);

    const active = view === linkTo
    return (
        <a className={"nav-item" + (active ? " active" : '')} onClick={ev => {
            ev.preventDefault();
            dispatch({
                view: linkTo,
                type: "setView"
            });
        }} href={url}>{linkTo}</a>
    )
}


export default Navbar